import { render } from "./metfone-layout.vue?vue&type=template&id=0343e750"
import script from "./metfone-layout.vue?vue&type=script&lang=js"
export * from "./metfone-layout.vue?vue&type=script&lang=js"

import "./metfone-layout.vue?vue&type=style&index=0&id=0343e750&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__